import { Box, InlineStack, Modal, Text, Tooltip } from "@shopify/polaris";
import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import utils from "../../../../utils/utils"
import { useSelector } from "react-redux";
import { store } from "../../../../store";
import { setInitialPath } from "../../../../slice";
// ai优化积分不足
const Index = ({ 
  userPoints,
  enoughPointsData,
  onClose
}) => {
  const router = useHistory();
  const shopify_level = useSelector(state => state.languageReducer.subScriptData.level);
  const handleViewDetail = () => {
    
    let sendMsg = `Hi, I'm a Premium user and I was wondering if it would be possible to receive additional AI optimization credits?`;

    try {
      // 填充信息并激活对话弹窗
      // window.Intercom('showNewMessage', sendMsg)
      window.Willdesk.show();
      window.Willdesk.chat(sendMsg);
    } catch (error) {
      console.info(error);
    }
};
  return (
    <div>
      <Modal
        open={enoughPointsData}
        onClose={onClose}
        title="Insufficient Points"
        secondaryActions={{
          onAction: () => {
            if (shopify_level === 5) {
              handleViewDetail()
              return
            }
            utils.routeJump1(router,'/admin/points')
          },
          content: shopify_level === 5 ? 'Contact us' : "Earn Points",
        }}
        primaryAction={shopify_level === 5 ? undefined :{
          onAction: () => {
            store.dispatch(setInitialPath("/admin/product_management?selectedView=0"));
            utils.routeJump1(router,'/admin/subscribe')
          },
          disabled:userPoints?.userPointsData?.available_points < 20,
          content:"Upgrade Plan",
        }}
      >
        <Modal.Section>
        <Box style={{border:'1px solid rgba(227, 227, 227, 1)',width:'max-content',background:'rgb(241, 241, 241)',borderRadius:'8px',padding:'6px'}}>
            <InlineStack blockAlign="center">
                <img src="/product_management/dsm_point.png" alt="Dropshipman" />
                <Tooltip content={`you have ${userPoints?.userPointsData?.available_points} points`} hasUnderline>
                <Text variant="bodyLg" fontWeight="bold" as="span">
                Points
                </Text>
            </Tooltip>
            <span style={{margin:'0 5px',color:'rgba(204, 204, 204, 1)'}}>|</span>
            <span style={{color:'rgba(0, 91, 211, 1)',fontSize:'13px',fontWeight:650}}>{userPoints?.userPointsData?.available_points}</span>
            </InlineStack>
        </Box>
        <Box className="ai-points-less-modal">
        Each AI optimization costs 20 points, but your current balance is insufficient.Ways to Earn Points:
        <ul style={{paddingLeft:'16px',margin:'0'}}>
        <li>Refer friends to Dropshipman (Free)</li>
        <li>Follow us on social media (Free)</li>
        <li>Purchase credits</li>
        <li>Place orders</li>
        <li>Complete starter tasks</li>
        <li>Subscribe to our plans
        </li>
        </ul>
        <div style={{marginTop:'8px'}}>
        Need More Points?
        </div>
        <ul style={{paddingLeft:'16px',margin:'0'}}>
        <li>Upgrade your plan for additional points</li>
        </ul>
        </Box>
        </Modal.Section>
      </Modal>
    </div>
  );
};

export default Index;
